module.exports = __webpack_public_path__ + "static/img/17.102298c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/17.png
// module id = 7U/X
// module chunks = 0